import { render, staticRenderFns } from "./BandejaCobro.vue?vue&type=template&id=9a12f52e"
import script from "./BandejaCobro.vue?vue&type=script&lang=js"
export * from "./BandejaCobro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports